import React, { useContext, useEffect, useState } from 'react';
import { bool, string } from 'prop-types';
import {
  params,
  string as stringType,
  shape as shapeType
} from '@thd-nucleus/data-sources';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import axios from 'axios';
import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
import { Drawer } from '@thd-olt-component-react/drawer';
import { ARContent } from './components/ARContent/ARContent.component';
import './AugmentedReality.style.scss';
import { ARInstructions } from './components/ARInstructions/ARInstructions';

export const AugmentedReality = ({ instructions, itemId }) => {
  const experienceContext = useContext(ExperienceContext);
  const [assetLink, setAssetLink] = useState('');
  const [loadedAsset, setLoadedAsset] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [supported, setSupported] = useState(false);

  // prefetch asset
  useEffect(() => {
    if (drawerOpen && instructions) {
      axios.get(assetLink).then(() => {
        setLoadedAsset(assetLink);
      }).catch(() => {
        // if something went wrong, don't block the user - give them degraded experience
        setLoadedAsset(assetLink);
      });
    }
  }, [drawerOpen]);
  // Check for support on load
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const anchor = window.document.createElement('a');
      if (anchor && anchor.relList && anchor.relList.supports('ar')) {
        setSupported(true);
      }
    }
  }, []);
  const { data, error, loading } = useProductDeprecated({ itemId, domains: ['media'] });
  // const { data, loading, error } = useDataModel('product', { variables: { itemId } });
  const { channel } = experienceContext;
  const isMobile = channel === 'mobile';

  if ((error && !data) || !data || loading || !isMobile || !supported) {
    return null;
  }

  const { product } = data || {};
  const { media } = product || {};
  const { augmentedRealityLink } = media || {};
  const { usdz } = augmentedRealityLink || {};

  if (!usdz) {
    return null;
  }
  if (!assetLink) {
    setAssetLink(`https://assets.homedepot-static.com/mobile-apps/3d/usdz/${usdz}`);
  }
  return (
    <>
      <ARContent assetLink={assetLink} onClick={instructions ? () => setDrawerOpen(true) : null} />
      {instructions && (
        <Drawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          position="bottom"
          width="100%"
          height="80%"
          closeOnOutsideClick
        >
          <ARInstructions loadedAsset={loadedAsset} onViewerClick={() => setDrawerOpen(false)} />
        </Drawer>
      )}
    </>
  );
};

AugmentedReality.displayName = 'AugmentedReality';

AugmentedReality.dataModel = {
  product: params({
    itemId: stringType().isRequired()
  })
    .shape({
      media: shapeType({
        augmentedRealityLink: shapeType({
          usdz: stringType()
        })
      })
    })
};

AugmentedReality.propTypes = {
  instructions: bool,
  itemId: string.isRequired
};

AugmentedReality.defaultProps = {
  instructions: false
};
